import { render } from "./DatoCalculado.vue?vue&type=template&id=f5127236"
import script from "./DatoCalculado.vue?vue&type=script&lang=js"
export * from "./DatoCalculado.vue?vue&type=script&lang=js"

import "./DatoCalculado.vue?vue&type=style&index=0&id=f5127236&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__